module.exports = __webpack_public_path__ + "static/banner-web-80fceaefa0dd52a6f10eff44b67d15bf.mp4";